import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppPostTabComponent } from './post.component';

const routes: Routes = [{ path: '', component: AppPostTabComponent }];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AppPostTabRoutingModule { }
